import { DialogTitle, DialogContent, Dialog, Grid, Link, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  BlockText,
  GridContainer,
  SecurityGuard,
  SecurityRole,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { buildFetchFileUrl, markFeedbackAsRead } from "../../../../axios/api/services";
import { toast } from "react-toastify";
import * as React from "react";
import { useState } from "react";

const FeedbackDetailsDialog = ({ open, setOpen, row, fetch }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [isMarkReadSubmitting, setIsMarkReadSubmitting] = useState(false);

  const handleMarkAsRead = () => {
    setIsMarkReadSubmitting(true);
    const asyncFeedbackMarkAsRead: AsyncCallArgs = {
      promise: markFeedbackAsRead(row.id),
      onSuccess: (response) => {
        setOpen(false);
        fetch();
        toast.success(t("m.feedback.mark.read.success"));
        setIsMarkReadSubmitting(false);
      },
      onError: () => {
        setIsMarkReadSubmitting(false);
      },
    };
    asyncCall(asyncFeedbackMarkAsRead);
  };

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => setOpen(false)}
        aria-labelledby="feedback-details-dialog-title"
      >
        <DialogTitle id="feedback-details-dialog-title" style={{ textAlign: "center" }}>
          {t("t.feedback.details.dialog")}
        </DialogTitle>
        <DialogContent>
          {row && (
            <GridContainer spacing={5}>
              <Grid item sm={12} md={12} lg={12}>
                <BlockText label={"t.feedback.text"} text={row.text} />
              </Grid>
              <Grid item sm={12} md={6} lg={6}>
                <Link download href={buildFetchFileUrl(row.file.relativePath, row.file.fileId, null)}>
                  {t("l.btn.attachment.save")}
                </Link>
              </Grid>
              <SecurityGuard checkForRoles={[SecurityRole.AcFeedbacksEdit]}>
                {!row.isRead && (
                  <Grid item sm={12} md={6} lg={6} style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleMarkAsRead}
                      disabled={isMarkReadSubmitting}
                    >
                      {t("l.btn.feedback.mark.read")}
                    </Button>
                  </Grid>
                )}
              </SecurityGuard>
            </GridContainer>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FeedbackDetailsDialog;
